<ng-container *ngIf="data?.title">
  <div mat-dialog-title
       [innerHTML]="data.title">
  </div>
</ng-container>

<mat-dialog-content>
  <ng-container *ngIf="contentRef">
    <ng-container *ngTemplateOutlet="contentRef"></ng-container>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions class="actions">
  <button *ngFor="let action of data.actions"
          mat-button
          (click)="onClickAction(action)"
          [color]="action.buttonColor"
          [attr.cdkFocusInitial]="action.initialFocus ? '' : null">
    {{action.label}}
  </button>
</mat-dialog-actions>
